const configs = {
	API: {
		BASE_URL: "https://app.prazos.digital",
		suffix: "/api/v1"
	},
	DAO: {
		prefix: "advogados_tasks"
	},
	mode: "production",
	version: "2.2.0.0",
	homePageRouteName: "",
	loadingConfigs: {
		color: "primary",
		backgroundColor: "#ffffffba",
		// type: 'radius',
		scale: 0.8
	},
	percentageTotalTimeForAlertDisplayed: 10
};

export default configs;
